import React, { useContext, useEffect } from 'react';
import { FormContext } from 'contexts/FormContext';
import { ApplicationName } from 'components/CASAForm';
import { useFormikContext } from 'formik';
import { get } from 'lodash';
import {
  AuTextInput,
  AuDateInput,
  AuControlInput,
  AuCallout,
  AuFormItemWrapper,
  AuDirectionLink,
  AuErrorText
} from 'components/DTA';

const AustralianPassportDetails: React.FC = () => {
  const { handleBack, setFormAlert, openStepById } = useContext(FormContext);
  const { errors, setFieldValue, getFieldMeta } = useFormikContext();
  const declarationFieldError = get(errors, 'auPassportDetails.declaration');

  useEffect(() => {
    setFieldValue('auPassportDetails.isManualUpload', false);
  }, []);

  const dvsValidationIndicator = getFieldMeta('auPassportDetails.dvsValidationIndicator').value;
  const isLocked = dvsValidationIndicator === 'Passed';

  const handleBackToIdentitySelection = () => {
    setFormAlert(null);
    openStepById('IdentityVerification');
  };
  return (
    <>
      <ApplicationName name='Australian passport details' />
      <AuDirectionLink
        onClick={handleBackToIdentitySelection}
        text="Back"
        direction="left" />
      <AuTextInput
        name='auPassportDetails.familyName'
        label='Family name'
        hintText='Please enter your family name (surname) as written on your passport'
        as='input'
        disabled={isLocked}
        block />
      <AuTextInput
        name='auPassportDetails.givenNames'
        label='Given names'
        hintText='Please enter all given names as written on your passport, including any middle names'
        as='input'
        disabled={isLocked}
        block />
      <AuDateInput
        name='auPassportDetails.dateOfBirth'
        label='Date of birth'
        disabled={isLocked}
        hintText='For example, 31 01 1990' />
      <AuTextInput
        name='auPassportDetails.passportNumber'
        label='Passport number'
        hintText='Please enter your passport number exactly as it appears on your passport'
        as='input'
        disabled={isLocked}
        block />
      <AuFormItemWrapper>
        <AuCallout title='' style={{ paddingTop: '0' }}>
          <AuControlInput
            name='auPassportDetails.declaration'
            id='checkbox-auPassportDetails-declaration'
            label=''
            type='checkbox'
            disabled={isLocked}
            hintText='I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming your identity'
          />
          {declarationFieldError && <AuErrorText text={declarationFieldError} />}
        </AuCallout>
      </AuFormItemWrapper>
    </>
  );
};

export default AustralianPassportDetails;